/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.321
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentConsumeMaterialUser,
	listRentConsumeMaterialUserInit,
	listRentConsumeMaterialUserByAuthorizations,
	deleteRentConsumeMaterialUser
} from '@api/rentmanage/RentConsumeMaterialUser';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentConsumeMaterialUser({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialUser(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentConsumeMaterialUserByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialUserByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentConsumeMaterialUserInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialUserInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentConsumeMaterialUser({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentConsumeMaterialUser({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
